import React from 'react';
import { Button, message } from 'antd';

export default class CardListForm extends React.Component {
	addCard = () => {
		if (this.props[this.props.thing].length >= this.props.maxLength) {
			message.warning(this.props.lengthWarning);
		}
		else {
			let s = {};
			s[this.props.thing] = [{}].concat(this.props[this.props.thing])
			this.props.onChange(s);
		}
	}
	editCard = (index) => {
		let newThings = this.props[this.props.thing].slice();
		for (let i in newThings) {
			if (newThings[i].index === index) {
				newThings[i].saved = false;
				break;
			} 
		}
		let s = {};
		s[this.props.thing] = newThings;
		this.props.onChange(s);
	}
	saveCard = (index, thing) => {
		thing.index = index;
		thing.saved = true;
		let newThings = this.props[this.props.thing].slice();
		for (let i in newThings) {
			if (newThings[i].index === index) {
				newThings.splice(i, 1, thing);
				break;
			} 
		}
		let s = {};
		s[this.props.thing] = newThings;
		this.props.onSave(thing, s, index);
	}
	removeCard = (index) => {
		let newThings = this.props[this.props.thing].slice();
		let thing = null;
		for (let i in newThings) {
			if (newThings[i].index === index) {
				thing = newThings.splice(i, 1);
				break;
			}
		}
		let s = {};
		s[this.props.thing] = newThings;
		this.props.onRemove(thing[0], s);
	}
	render() {
		const childProps = {
			onEdit: this.editCard,
			onSave: this.saveCard,
			onRemove: this.removeCard
		};
		return (
			<div className="withSpacing">
				{!this.props.disabled &&
					<Button size="large" icon="plus" type="primary" onClick={this.addCard}>
						Add {this.props.title}
					</Button>
				}
				{React.Children.map(this.props.children, child => 
					React.cloneElement(child, {...childProps})
				)}
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./portal-components/CardListForm/index.jsx